import { useCallback } from 'react';

export default function useReload() {
    return useCallback(() => {
        window.location.reload();
    }, []);
}
